import React from 'react';
import {styled} from '@volkswagen-onehub/components-core';
import WeChargeLogo from './We_Charge_coloured_L_76@3x.svg';

export function Logo(): JSX.Element {
  return (
    <StyledSvg>
      <WeChargeLogo />
    </StyledSvg>
  );
}

const StyledSvg = styled.div`
  line-height: 0;

  svg {
    height: 40px;
  }
`;
